import styles from "./History.module.scss";

type HistoryProps = {
  options: string[];
};

export const History = ({ options }: HistoryProps) => {
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.header}>HISTORIE</h3>
      <h4 className={styles.description}>
        Bekijk hier jouw persoonlijke historie. Selecteer via de filter functie
        welke details je wilt inzien.
      </h4>
      {options.map((el) => (
        <button key={el} className={styles.historyElement}>
          {el}
        </button>
      ))}
    </div>
  );
};
